export enum SubmitState {
  waitingForInput = 'waitingForInput',
  loading = 'loading',
  error = 'error'
}
